import { commitMutation } from 'react-relay';
import graphql from 'babel-plugin-relay/macro';
import AbEnvironment from '../auth/AbEnvironment';

const abEnvironment = new AbEnvironment();
    
const mutation = graphql`
  mutation ResellerFeeUpdateMutation($input: UpdateAccountTByAccountIdInput!) {
    updateAccountTByAccountId(input: $input) {
      accountT {
        accountId
        feeMonthly
        feeCustPercentage
        feeSelfPercentage    
      }
    }
  }
  `;

  function commit(accountId, feeMonthly, feeCustPercentage, feeSelfPercentage ) {
    var variables = {
        input: {
            accountId,
            accountTPatch: {}
        }
    };

    variables.input.accountTPatch.feeMonthly = feeMonthly;
    variables.input.accountTPatch.feeCustPercentage = feeCustPercentage;
    variables.input.accountTPatch.feeSelfPercentage = feeSelfPercentage;
 
    return new Promise((resolve, reject) => {
        commitMutation(
            abEnvironment.getEnvironment(), {
              mutation,
              variables,
              updater: (store) => {
                // Mutation store - values that have been updated / returned
                const payload = store.getRootField('updateAccountTByAccountId');
                const theAccount = payload.getLinkedRecord('accountT');

                // Retrieved store - assumes that all callers are components that have queried
                // account using 'accountTByAccountId'.
                const theRoot = store.getRoot();
                const preSaveAccountId = 'accountTByAccountId(accountId:"' + accountId + '")';
                const preSaveAccount = theRoot.getLinkedRecord(preSaveAccountId);

                // Could restrict to just what has changed, but just do all returned values,
                // which is correct.
                if (preSaveAccount != null) {
                  preSaveAccount.setValue(theAccount.getValue('feeMonthly'),         'feeMonthly');
                  preSaveAccount.setValue(theAccount.getValue('feeCustPercentage'),  'feeCustPercentage');
                  preSaveAccount.setValue(theAccount.getValue('feeSelfPercentage '), 'feeSelfPercentage');   
                }
              },
              onCompleted: (response) => {
                resolve(response);
              },
              onError: (error) => {
                reject(error);
              }
        }); 
    });
  }
  /* eslint import/no-anonymous-default-export: [2, {"allowObject": true}] */
  export default { commit };
  